import { OfflinePrefetchProps } from "../interface";
import {
  usePrefetchUtils,
  executeSimplePrefetch,
} from "../utils/usePrefetchUtils";
import { useDispatch } from "react-redux";
import { useLazyGetFormIndexQuery } from "../../../api/formsApi";
import { storeForms } from "../../../../store/slices/forms";
import { useCallback } from "react";

export function usePrefetchForms({ enabled }: OfflinePrefetchProps) {
  const dispatch = useDispatch();
  const [trigger] = useLazyGetFormIndexQuery();

  const handlePrefetch = useCallback(async () => {
    await executeSimplePrefetch({
      name: "Forms",
      fetchFn: async () => {
        const { data } = await trigger({});
        if (data) dispatch(storeForms(data));
      },
    });
  }, [trigger, dispatch]);

  usePrefetchUtils({
    enabled,
    prefetchHandler: handlePrefetch,
  });
}
